import type { OrgProjectScope } from "@/lib/resource-context";

export const projectCapabilitiesKey = (scope: OrgProjectScope) =>
  ["capabilities", "project", scope.organizationId, scope.projectId] as const;

export const orgCapabilitiesKey = (organizationId: string) =>
  ["capabilities", "org", organizationId] as const;
